import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useGetPatientById } from '_api';
import { PatientCard } from 'components/organisms';
import { PatientProfileTableView } from 'components/templates';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export const Patient = () => {
  const { patientId: id } = useParams();
  const patientId = useMemo(() => (id !== undefined ? Number(id) : 0), [id]);
  const { data: patient, isFetching: isLoading } = useGetPatientById(patientId);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(1100));
  const therapistId = patient ? patient.therapists[0].id : 0;

  return (
    <Container>
      {patientId !== 0 && patient && !isLoading ? (
        <Grid
          container
          spacing={20}
          direction={!isSmallScreen ? 'row' : 'column'}
          sx={{ width: '100%' }}
        >
          <Grid
            item
            md={4}
            sx={
              isSmallScreen
                ? { paddingX: '20px', margin: 'auto', width: '100%' }
                : { margin: 'atuo', width: '100%' }
            }
          >
            <Card
              sx={
                !isSmallScreen
                  ? {
                      position: 'fixed',
                      maxHeight: 'calc(100vh - 180px)',
                      maxWidth: '400px',
                      overflowY: 'auto',
                      width: '100%',
                    }
                  : {}
              }
            >
              <CardContent>
                <PatientCard patient={patient} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={8}>
            <Box sx={isSmallScreen ? { padding: '20px' } : { paddingLeft: '50px' }}>
              <PatientProfileTableView
                patientId={patientId}
                therapistId={Number(therapistId)}
              />
            </Box>
          </Grid>
        </Grid>
      ) : null}
    </Container>
  );
};
